/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState, useMemo } from 'react';
import {
  Table,
  Empty,
  Skeleton,
  Result,
  DatePicker,
  Card,
  Tag,
  Input,
  Select,
  Pagination,
  Row,
  Col,
  Badge,
  Button,
  Popconfirm,
  Divider
} from 'antd';
import dayjs from 'dayjs';
import useFetchData from '../../hooks/useFetchData';
import { getRoleResponse } from '../../utils/format';

const { RangePicker } = DatePicker;
const { Option } = Select;

const DAYS = [
  { label: 'Dimanche', value: 0 },
  { label: 'Lundi', value: 1 },
  { label: 'Mardi', value: 2 },
  { label: 'Mercredi', value: 3 },
  { label: 'Jeudi', value: 4 },
  { label: 'Vendredi', value: 5 },
  { label: 'Samedi', value: 6 }
];

function ReportAttendance() {
  const today = dayjs();
  const [query, setQuery] = useState({
    startDate: today.startOf('month').format('YYYY-MM-DD'),
    endDate: today.endOf('month').format('YYYY-MM-DD'),
    dayOfWeek: 0
  });

  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedUser, setSelectedUser] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  // 🔹 Fetch API
  const [loading, error, response] = useFetchData(
    `/attendance/report?startDate=${query.startDate}&endDate=${query.endDate}&dayOfWeek=${query.dayOfWeek}`,
    query.startDate + query.endDate + query.dayOfWeek
  );

  const [data, setData] = useState([]);

  useEffect(() => {
    if (response?.data?.rows) setData(response.data.rows);
  }, [response]);

  // 🔹 Filtre global par recherche
  const filteredData = useMemo(() => {
    if (!searchTerm) return data;
    const term = searchTerm.toLowerCase();
    return data.filter((u) => `${u.civility || ''} ${u.firstname || ''} ${u.quartier || ''} ${u.role || ''}`
      .toLowerCase()
      .includes(term));
  }, [data, searchTerm]);

  // 🔹 Tri global sur toutes les données
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;
    const sorted = [...filteredData].sort((a, b) => {
      let valA = a[sortConfig.key];
      let valB = b[sortConfig.key];

      if (sortConfig.key === 'firstname') {
        valA = `${a.civility || ''} ${a.firstname || ''}`.toLowerCase();
        valB = `${b.civility || ''} ${b.firstname || ''}`.toLowerCase();
        return valA.localeCompare(valB) * (sortConfig.direction === 'ascend' ? 1 : -1);
      }

      valA = Number(valA);
      valB = Number(valB);
      return (valA - valB) * (sortConfig.direction === 'ascend' ? 1 : -1);
    });
    return sorted;
  }, [filteredData, sortConfig]);

  // 🔹 Pagination
  const paginated = sortedData.slice((page - 1) * pageSize, page * pageSize);

  // 🔹 Popconfirm contenu
  const renderPopContent = (user) => (
    <div style={{
      maxHeight: 300, overflowY: 'auto', padding: '8px 12px', width: 250
    }}
    >
      {user.presentDates?.length > 0 && (
        <div style={{ marginBottom: 10 }}>
          <h4 style={{ marginBottom: 6, color: 'green' }}>🟢 Présent :</h4>
          {user.presentDates.map((d) => (
            <div key={d} style={{ marginBottom: 4 }}>
              <Badge color='green' text={dayjs(d).format('ddd DD/MM/YYYY')} />
            </div>
          ))}
        </div>
      )}

      {user.absentDates?.length > 0 && (
        <div style={{ marginBottom: 10 }}>
          <Divider style={{ margin: '8px 0' }} />
          <h4 style={{ marginBottom: 6, color: 'red' }}>🔴 Absent :</h4>
          {user.absentDates.map((d) => (
            <div key={d} style={{ marginBottom: 4 }}>
              <Badge color='red' text={dayjs(d).format('ddd DD/MM/YYYY')} />
            </div>
          ))}
        </div>
      )}

      {(!user.presentDates?.length && !user.absentDates?.length) && (
        <div style={{ textAlign: 'center', color: '#999' }}>
          Aucune donnée de présence ou d'absence
        </div>
      )}
    </div>
  );

  // 🔹 Colonnes du tableau avec tri
  const columns = [
    {
      title: 'Nom',
      key: 'firstname',
      sortOrder: sortConfig.key === 'firstname' ? sortConfig.direction : null,
      onHeaderCell: () => ({
        onClick: () => {
          setSortConfig((prev) => ({
            key: 'firstname',
            direction: prev.key === 'firstname' && prev.direction === 'ascend' ? 'descend' : 'ascend'
          }));
        }
      }),
      render: (_, record) => {
        const civility = record?.civility || '';
        const firstname = record?.firstname || '';
        const quartier = record?.quartier ? `(${record.quartier})` : '';
        const role = record?.role || '';
        return (
          <span>
            {`${civility} ${firstname} ${quartier}`}
            <span className='float-right'>
              <Tag color={getRoleResponse(role, true).color}>{role}</Tag>
            </span>
          </span>
        );
      }
    },
    {
      title: 'Présences',
      dataIndex: 'presentCount',
      align: 'center',
      sortOrder: sortConfig.key === 'presentCount' ? sortConfig.direction : null,
      onHeaderCell: () => ({
        onClick: () => {
          setSortConfig((prev) => ({
            key: 'presentCount',
            direction: prev.key === 'presentCount' && prev.direction === 'ascend' ? 'descend' : 'ascend'
          }));
        }
      })
    },
    {
      title: 'Absences',
      dataIndex: 'absentCount',
      align: 'center',
      sortOrder: sortConfig.key === 'absentCount' ? sortConfig.direction : null,
      onHeaderCell: () => ({
        onClick: () => {
          setSortConfig((prev) => ({
            key: 'absentCount',
            direction: prev.key === 'absentCount' && prev.direction === 'ascend' ? 'descend' : 'ascend'
          }));
        }
      })
    },
    {
      title: '% Présence',
      key: 'presenceRate',
      align: 'center',
      render: (_, record) => {
        const total = record.presentCount + record.absentCount;
        const percent = total > 0 ? ((record.presentCount / total) * 100).toFixed(0) : 0;
        return (
          <Tag color={percent >= 80 ? 'green' : percent >= 50 ? 'orange' : 'red'}>
            {percent}
            %
          </Tag>
        );
      }
    },
    {
      title: 'Phone',
      key: 'phone',
      render: (_, record) => {
        const phone = record?.phone || '';
        return (
          <span>
            {`${phone}`}
          </span>
        );
      }
    },
    {
      title: 'Détails',
      key: 'details',
      align: 'center',
      render: (_, record) => (
        <Popconfirm
          title={renderPopContent(record)}
          placement='rightTop'
          okButtonProps={{ style: { display: 'none' } }}
          cancelText='Fermer'
          onCancel={() => {}}
        >
          <Button size='small'>Voir</Button>
        </Popconfirm>
      )
    }
  ];

  return (
    <div>
      {/* 🔹 Filtres */}
      <Card className='mb-4'>
        <Row gutter={16}>
          <Col>
            <RangePicker
              value={[dayjs(query.startDate), dayjs(query.endDate)]}
              onChange={(dates) => {
                if (dates) {
                  setQuery((prev) => ({
                    ...prev,
                    startDate: dates[0]?.format('YYYY-MM-DD'),
                    endDate: dates[1]?.format('YYYY-MM-DD')
                  }));
                  setPage(1);
                }
              }}
            />
          </Col>
          <Col>
            <Select
              className='w-fit'
              value={query.dayOfWeek}
              onChange={(v) => setQuery((prev) => ({ ...prev, dayOfWeek: v }))}
              style={{ width: 140 }}
            >
              {DAYS.map((d) => (
                <Option key={d.value} value={d.value}>
                  {d.label}
                </Option>
              ))}
            </Select>
          </Col>
          <Col>
            <Input
              placeholder='Rechercher un nom ou quartier...'
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
              allowClear
              style={{ width: 250 }}
            />
          </Col>
        </Row>
      </Card>

      {/* 🔹 Table principale */}
      {error ? (
        <Result status='error' title='Erreur' subTitle={error} />
      ) : (
        <Skeleton loading={loading} active paragraph={{ rows: 8 }}>
          {filteredData.length === 0 ? (
            <Empty description='Aucune donnée' />
          ) : (
            <>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={paginated}
                pagination={false}
                bordered
                components={{
                  header: {
                    cell: (props) => <th {...props} style={{ cursor: 'pointer' }}>{props.children}</th>
                  }
                }}
              />
              <Pagination
                className='my-5'
                current={page}
                total={sortedData.length} // prend en compte le tri global
                pageSize={pageSize}
                onChange={(p, size) => {
                  setPage(p);
                  setPageSize(size);
                }}
              />
            </>
          )}
        </Skeleton>
      )}
    </div>
  );
}

export default React.memo(ReportAttendance);
